var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAccept = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12.526,
  height: 10.09,
  viewBox: "0 0 12.526 10.09",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M10.612,33.286,4.349,39.547,1.914,37.114,0,39.028l4.349,4.348L12.526,35.2Z",
  transform: "translate(0 -33.286)"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccept, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/accept.7e49c760.svg";
export { ForwardRef as ReactComponent };